import { render, staticRenderFns } from "./TabComponentPhoto.vue?vue&type=template&id=79251a2b&scoped=true"
import script from "./TabComponentPhoto.vue?vue&type=script&lang=js"
export * from "./TabComponentPhoto.vue?vue&type=script&lang=js"
import style0 from "./TabComponentPhoto.vue?vue&type=style&index=0&id=79251a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79251a2b",
  null
  
)

export default component.exports